<template>
<div class="transfer-details--inner">
  <h1>Transfer {{$route.params.type}}</h1>
  <table>
    <tr>
      <th>id</th>
      <th>user id</th>
      <th>old balance</th>
      <th>amount</th>
      <th>status</th>
      <th>created at</th>
    </tr>
    <tr v-if="!transferDetails.length" class="no-data">
      <td colspan="5">NO DATA</td>
    </tr>
    <tr
      v-for="(transfer, x) in transferDetails"
      :key="x"
    >
      <td>{{transfer.id}}</td>
      <td>{{transfer.user.login_name}}</td>
      <td>{{transfer.old_balance}}</td>
      <td>{{transfer.amount}}</td>
      <td>{{transfer.status}}</td>
      <td>{{transfer.created_at | dateFormat}}</td>
    </tr>
  </table>

  <!--- sample pagination --->
  <pagination :total="1000000" :limit="10" v-model="params.page" :rows="10" @page="search"></pagination>

</div>
</template>
<script type="text/javascript">
import Pagination from '@/components/base/Pagination'
import { mapState, mapActions } from 'vuex'
import moment from 'moment'

export default {
  name: 'transfer-details',

  components: { Pagination },
  filters: {
    dateFormat (date) {
      if (!date) return 'non'
      return moment(date).format('MMMM Do YYYY, h:mm:ss a')
    }
  },

  computed: {
    ...mapState('transfer', ['transferDetails'])
  },

  data () {
    return {
      type: '',
      params: {
        page: 1
      }
    }
  },

  async created () {
    await this.getDetail({
      type: this.$route.params.type,
      uid: this.$route.params.uid
    })
  },

  methods: {
    ...mapActions('transfer', ['getDetail']),

    async setPage (type) {
      if (type === 'next') {
        this.page++
      }

      if (type === 'prev' && this.page > 1) {
        this.page--
      }

      await this.getDetail({
        type: this.$route.params.type,
        uid: this.$route.params.uid,
        params: {
          page: this.page
        }
      })
    },

    async search (page) {
      this.params.page = page
      await this.getDetail({
        type: this.$route.params.type,
        uid: this.$route.params.uid,
        params: this.params
      })
    }
  }
}
</script>
<style type="text/css">
th, td {
  padding: 4px
}
th {
  background: #2a3642
}
.no-data {
  text-align: center;
}

</style>
